import { render } from "./appuntamentoCentroFumo.vue?vue&type=template&id=9b7b7b44&ts=true"
import script from "./appuntamentoCentroFumo.vue?vue&type=script&lang=ts"
export * from "./appuntamentoCentroFumo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__